const appStoreLink = import.meta.env.VITE_BRAND_APPSTORE_URL
const googlePlayLink = import.meta.env.VITE_BRAND_GOOGLE_PLAY_URL
const huaweiLink = import.meta.env.VITE_BRAND_HUAWEI_URL

const appLinks = [
  {
    icon: '/icons/mobile-app/apple.svg',
    href: appStoreLink,
  },
  {
    icon: '/icons/mobile-app/play-market.svg',
    href: googlePlayLink,
  },
  {
    icon: '/icons/mobile-app/huawei-gallery.svg',
    href: huaweiLink,
  },
]

export const UNIFIED_APP_LINK = import.meta.env.VITE_BRAND_UNIFIED_APP_LINK

export const APPS = appLinks.filter((app) => app.href)

export const BRAND_NAME: string = import.meta.env?.VITE_BRAND_NAME || 'Тобыл'
